<div *ngFor="let field of fields; trackBy: trackByFieldId">
  <ng-container [ngSwitch]="field.type">
    <div class="mb-3" *ngSwitchCase="'text'">
      <div class="field-preview-header">
        <div>
          <label class="form-label mb-0" [attr.for]="'f_' + field.fieldId">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" title="Edit field" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" title="Remove field"
            (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <input type="text" class="form-control" [id]="'f_' + field.fieldId" [ngModel]="textLikeValue(field)"
        (ngModelChange)="emitPatch(field, { defaultValue: $event })" [placeholder]="field.placeholder || ''" />
      <small *ngIf="field.placeholderAr" class="d-block text-muted mt-1" dir="rtl">{{ field.placeholderAr }}</small>
    </div>

    <div class="mb-3" *ngSwitchCase="'number'">
      <div class="field-preview-header">
        <div>
          <label class="form-label mb-0" [attr.for]="'fn_' + field.fieldId">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <input type="number" class="form-control" [id]="'fn_' + field.fieldId" [ngModel]="field.defaultValue"
        (ngModelChange)="emitPatch(field, { defaultValue: $event })" [placeholder]="field.placeholder || ''" />
      <small *ngIf="field.placeholderAr" class="d-block text-muted mt-1" dir="rtl">{{ field.placeholderAr }}</small>
    </div>

    <div class="mb-3" *ngSwitchCase="'textarea'">
      <div class="field-preview-header">
        <div>
          <label class="form-label mb-0" [attr.for]="'fta_' + field.fieldId">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <textarea class="form-control" [id]="'fta_' + field.fieldId" rows="3" [ngModel]="textLikeValue(field)"
        (ngModelChange)="emitPatch(field, { defaultValue: $event })" [placeholder]="field.placeholder || ''"></textarea>
      <small *ngIf="field.placeholderAr" class="d-block text-muted mt-1" dir="rtl">{{ field.placeholderAr }}</small>
    </div>

    <div class="mb-3" *ngSwitchCase="'file'">
      <div class="field-preview-header">
        <div>
          <label class="form-label mb-0" [attr.for]="'ff_' + field.fieldId">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <small class="text-muted d-block mb-1">Accept: <strong>{{ fileAcceptAttr(field) }}</strong></small>
      <input type="file" class="form-control" [id]="'ff_' + field.fieldId" [attr.accept]="fileAcceptAttr(field)"
        (change)="onFileChosen(field, $event)" />
    </div>

    <div class="field-checkbox mb-3" *ngSwitchCase="'checkbox'">
      <div class="field-preview-header">
        <div>
          <strong>{{ field.label }}</strong>
          <small *ngIf="field.labelAr" class="d-block text-muted fw-normal" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <div *ngIf="!field.multipleOptions && hasOptionList(field)" class="d-flex flex-column gap-2">
        <small class="text-muted">Pick one option (checkbox style)</small>
        <div *ngFor="let option of getOptions(field)" class="field-checkbox d-flex align-items-center gap-2">
          <p-checkbox [inputId]="field.fieldId + '_ex_' + option.value" [binary]="true"
            [ngModel]="isExclusiveChecked(field, option.value)"
            (ngModelChange)="toggleExclusiveCheckbox(field, option.value, $event)"></p-checkbox>
          <label [for]="field.fieldId + '_ex_' + option.value">{{ option.label }}</label>
        </div>
      </div>

      <div *ngIf="!field.multipleOptions && !hasOptionList(field)" class="d-flex align-items-center gap-2">
        <p-checkbox [binary]="true" [ngModel]="!!field.defaultValue"
          (ngModelChange)="emitPatch(field, { defaultValue: $event })" [inputId]="'cb_' + field.fieldId"></p-checkbox>
        <label [for]="'cb_' + field.fieldId">{{ field.label }}</label>
      </div>

      <div *ngIf="field.multipleOptions" class="d-flex flex-column gap-2">
        <div *ngFor="let option of getOptions(field)" class="field-checkbox d-flex align-items-center gap-2">
          <p-checkbox [inputId]="field.fieldId + '_' + option.value" [binary]="true"
            [ngModel]="isOptionChecked(field, option.value)"
            (ngModelChange)="toggleMultiCheckbox(field, option.value, $event)"></p-checkbox>
          <label [for]="field.fieldId + '_' + option.value">{{ option.label }}</label>
        </div>
      </div>
    </div>

    <div class="field-radiobutton mb-3" *ngSwitchCase="'radio'">
      <div class="field-preview-header">
        <div>
          <label class="form-check-label mb-0 d-block">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <div *ngFor="let radio of getOptions(field)" class="field-checkbox mb-2 d-flex align-items-center gap-2">
        <p-radioButton [inputId]="field.fieldId + '_r_' + radio.value" [name]="'rad_' + field.fieldId"
          [value]="radio.value" [ngModel]="field.defaultValue"
          (ngModelChange)="emitPatch(field, { defaultValue: $event })" />
        <label [for]="field.fieldId + '_r_' + radio.value">{{ radio.label }}</label>
      </div>
    </div>

    <div class="mb-3" *ngSwitchCase="'select'">
      <div class="field-preview-header">
        <div>
          <label class="form-label mb-0">{{ field.label }}</label>
          <small *ngIf="field.labelAr" class="d-block text-muted" dir="rtl">{{ field.labelAr }}</small>
        </div>
        <div class="field-preview-actions">
          <button type="button" class="btn btn-link p-0 me-2" (click)="requestEdit(field, $event)">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button type="button" class="btn btn-link text-danger p-0" (click)="confirmRemove($event, field)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <p-dropdown [options]="getOptions(field)" placeholder="Select an option" optionLabel="label" optionValue="value"
        [showClear]="true" [ngModel]="field.defaultValue" (ngModelChange)="emitPatch(field, { defaultValue: $event })"
        [style]="{ width: '100%' }"></p-dropdown>
    </div>
  </ng-container>
</div>

<p-confirmPopup></p-confirmPopup>